import './TagsView.scss';

import TagsView from './TagsView';

export default TagsView;
